import React, { useEffect, useState } from "react";
import { Col, Row, Card, Table, Breadcrumb, Badge } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
import axios from "axios";
import config from "../../config";
import { useAuth } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import { VscFlame } from "react-icons/vsc";
import { PiFlagBannerFill } from "react-icons/pi";
import noUserImg from '../../assets/images/no_user.png'; // Placeholder for missing profile images
import { getSocket } from "../../context/socket";
import View_edit_taskdetails from "../../modalPopup/View_edit_taskdetails";
import { Dialog } from "primereact/dialog";
const Daily_task_Admin = () => {
    const { accessToken } = useAuth();
    const [visibleTaskSheets, setVisibleTaskSheets] = useState({});
    const [selectedMonth, setSelectedMonth] = useState(() => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1); // Sets to the first day of the current month
    });


    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [selectedBoardId, setSelectedBoardId] = useState(null);
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState("top-right");



    const [tasksheetsData, setTasksheetsData] = useState({});
    const [employeeData, setEmployeeData] = useState([]);
    const [loading, setLoading] = useState(false);

    const socket = getSocket();

    const getFormattedDates = (year, month) => {
        const dates = [];
        const date = new Date(year, month - 1, 1);
        const formatter = new Intl.DateTimeFormat("en-GB", {
            weekday: "short",
            month: "short",
            day: "numeric",
            year: "numeric",
        });

        while (date.getMonth() === month - 1) {
            dates.push({
                formatted: formatter.format(date),
                plainDate: `${year}-${String(month).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`, // Plain date format
                day: date.getDay(),
            });
            date.setDate(date.getDate() + 1);
        }
        return dates;
    };

    const handleMonthChange = (e) => {
        setSelectedMonth(e.value);
    };

    const [year, month] = selectedMonth
        ? [selectedMonth.getFullYear(), selectedMonth.getMonth() + 1]
        : [new Date().getFullYear(), new Date().getMonth() + 1];

    const daysInMonth = getFormattedDates(year, month);

    const getDateRange = () => {
        const startDate = `${year}-${String(month).padStart(2, "0")}-01`;
        const endDate = `${year}-${String(month).padStart(2, "0")}-${new Date(year, month, 0).getDate()}`;
        return { start_date: startDate, end_date: endDate };
    };


    useEffect(() => {
        const { start_date, end_date } = getDateRange();

        setLoading(true);
        socket.emit("fetchAllTaskSheetsByDate", { start_date, end_date });

        const handleFetched = ({ success, data }) => {
            if (success) {
                setTasksheetsData(data);

                console.log(data);
                const employees = Object.values(data).map(({ userDetails, missedDeadlineCounts }) => ({
                    id: userDetails.user_id,
                    name: userDetails.name,
                    avatar: userDetails.profileImage || noUserImg,
                    missedTrueCount: missedDeadlineCounts.missedTrueCount,
                    missedFalseCount: missedDeadlineCounts.missedFalseCount
                }));
                setEmployeeData(employees);
            }
            setLoading(false);
        };

        socket.on("allTaskSheetsFetched", handleFetched);

        return () => {
            socket.off("allTaskSheetsFetched", handleFetched);
        };
    }, [selectedMonth]);


    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const options = { day: 'numeric', month: 'short' }; // e.g., "7 Apr"
        return date.toLocaleDateString('en-US', options);
    };

    const getDueDateClass = (dueDate) => {
        if (!dueDate) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const due = new Date(dueDate);
        due.setHours(0, 0, 0, 0);

        const diffDays = (due - today) / (1000 * 60 * 60 * 24);

        if (diffDays < 0) {
            return "bg-danger"; // Passed
        } else if (diffDays === 0) {
            return "bg-danger"; // Today
        } else if (diffDays === 1) {
            return "bg-warning"; // Tomorrow
        } else {
            return "bg-success"; // Future
        }
    };

    const handleDialogClose = () => {
        setVisible(false);
        setSelectedTaskId(null);
        setSelectedBoardId(null);
    };
    return (
        <Row className="body_content">
            <Row className="mx-0">
                <Col md={6} lg={6} className="mb-4">
                    <Breadcrumb>
                        <Breadcrumb.Item active>Task Sheet</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col md={6} lg={6} className="mb-4 d-flex justify-content-end align-items-center">
                    <label>Filter by Month</label>
                    <Calendar
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        view="month"
                        dateFormat="MM yy"
                        placeholder="Choose a month"
                        showButtonBar
                        className="ms-3 py-0"
                        style={{ width: "170px", height: "38px" }}
                    />
                </Col>
                <Col lg={12}>
                    <Card>
                        <div className="table-responsive tasksheetTable">
                            {loading ? (
                                <p>Loading tasksheets...</p>
                            ) : (
                                <Table className="employee-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "100px" }} className="sticky-header">Day</th>
                                            {employeeData.map((emp, idx) => (
                                                <th key={idx} className="sticky-header" style={{ width: "320px" }}>
                                                    <div className="d-flex align-items-center justify-content-center">
                                                        <img src={emp.avatar} alt={emp.name} style={{ width: 30, height: 30, borderRadius: "50%", marginRight: 10 }} />
                                                        {emp.name}
                                                    </div>
                                                    <ol className="countPro">
                                                        <li><span><small>On Time:</small> {emp.missedFalseCount}</span></li>
                                                        <li><span><small>Missed:</small> {emp.missedTrueCount}</span></li>
                                                    </ol>
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {daysInMonth.map(({ formatted, plainDate, day }, idx) => (
                                            <tr key={idx} className={day === 0 || day === 6 ? "weekend-row" : ""}>
                                                <td className={`sticky-column ${day === 0 || day === 6 ? "weekend-cell" : ""}`}>
                                                    {formatted}
                                                </td>
                                                {employeeData.map((emp, empIdx) => {
                                                    const userTasks = tasksheetsData[emp.id]?.tasksheets[plainDate] || [];
                                                    return (
                                                        <td key={empIdx}>
                                                            <ul>
                                                                {userTasks.map((sheet, taskIdx) => (
                                                                    <li key={taskIdx} className="position-relative" 
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                      }}
                                                                      
                                                                     onClick={(e) => {
                                                                        e.stopPropagation();
                                                                        setVisibleTaskSheets({});
                                                                        setSelectedTaskId(sheet.card.card_id);
                                                                        setSelectedBoardId(sheet.card.board_id);
                                                                        setVisible(true);
                                                                        setPosition("top-right");
                                                                      }}>
                                                                        
                                                                            <p><span>Brand:</span> {sheet.card?.list?.board?.brand?.brand_name || "N/A"}
                                                                                {sheet.card?.priority === 'Urgent' && (
                                                                                    <small className="misses_image2">
                                                                                        <PiFlagBannerFill className="ms-3" />
                                                                                    </small>
                                                                                )}
                                                                            </p>
                                                                            {sheet.card?.missed_deadline && (
                                                                                <div className="misses_image">
                                                                                    <VscFlame />
                                                                                </div>
                                                                            )}
                                                                            <p><span>Project:</span> {sheet.card?.list?.board?.project?.project_name || "N/A"}</p>
                                                                            <p><span>Task:</span> {sheet.card?.title}</p>
                                                                            <p>
                                                                                <small className="text-muted">
                                                                                    <b style={{ fontSize: '12px' }}>In List: </b>
                                                                                    <span
                                                                                        style={{
                                                                                            fontSize: '12px',
                                                                                            color: sheet.card?.list?.color_code || '#ccc',
                                                                                            padding: '0px 5px',
                                                                                            borderRadius: '4px',
                                                                                            display: 'inline-block'
                                                                                        }}
                                                                                    >
                                                                                        {sheet.card?.list?.name}
                                                                                    </span>
                                                                                </small>
                                                                            </p>


                                                                            <div className="mb-0 d-flex justify-content-between align-items-center me-2">
                                                                                <p>
                                                                                    <span>Work Done:</span>
                                                                                </p>
                                                                                <p>
                                                                                    <button
                                                                                        className="btn btn-link p-0"
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation(); // prevent triggering any parent click
                                                                                            const key = `${emp.id}_${sheet.card.card_id}`;
                                                                                            setVisibleTaskSheets(prev => ({
                                                                                                ...prev,
                                                                                                [key]: !prev[key]
                                                                                            }));
                                                                                        }}
                                                                                    >
                                                                                        {visibleTaskSheets[`${emp.id}_${sheet.card.card_id}`] ? "Hide" : "Show"}
                                                                                    </button>
                                                                                </p>
                                                                            </div>
                                                                            {visibleTaskSheets[`${emp.id}_${sheet.card.card_id}`] && sheet.taskSheets.map((ts, i) => (
                                                                                <div key={`ts-${ts.tasksheet_id}-${i}`} className="ps-3 border-bottom">
                                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                                        <p className="mb-0">
                                                                                            <span>Task Stage:</span>
                                                                                            <Badge pill className="ms-2">
                                                                                                {ts.status || 'No status'}
                                                                                            </Badge>
                                                                                        </p>
                                                                                        {ts.missed_deadline && (
                                                                                            <div className="text-danger">
                                                                                                <VscFlame />
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                    {ts.checklist && (
                                                                                        <p className="mb-0 text-muted">
                                                                                            <span> Subtask Name:</span> <span>{ts.checklist.name}</span>{' '}
                                                                                            <span style={{ color: ts.checklist.is_checked ? 'green' : 'red' }}>
                                                                                                {ts.checklist.is_checked ? '✓' : '✗'}
                                                                                            </span>
                                                                                        </p>
                                                                                    )}
                                                                                    <p className="mb-0 text-muted">
                                                                                        <span>Work:</span> <span>{ts.note || 'No note'}</span>
                                                                                    </p>
                                                                                </div>
                                                                            ))}

                                                                            <p className="text-danger text-bold">
                                                                                <small className={`text-white rounded ${getDueDateClass(sheet.card?.due_date)}`} style={{ fontSize: '11px', padding: '2px 5px' }}>
                                                                                    <i className="pi pi-calendar" style={{ fontSize: '11px' }}></i>
                                                                                    {" "}{formatDate(sheet.card?.createdAt)} - {formatDate(sheet.card?.due_date)}
                                                                                </small>
                                                                            </p>

                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            )}
                        </div>
                    </Card>
                </Col>

                <Dialog
                    visible={visible}
                    position={position}
                    style={{ width: '1000px', margin: '0', borderRadius: '0', height: '100%' }}
                    onHide={handleDialogClose}
                    draggable={false}
                    resizable={false}
                    className="KanbanDialog"
                >
                    {selectedTaskId && selectedBoardId && (
                        <View_edit_taskdetails
                            taskId={selectedTaskId}
                            boardId={selectedBoardId}
                            onClose={handleDialogClose}
                        />
                    )}
                </Dialog>

            </Row>
        </Row>
    );
};

export default Daily_task_Admin;
